module.exports = __webpack_public_path__ + "img/AdobeStock_Pink_Door.65915f45.jpeg";